export default {"src":"/_next/static/media/logo-header-branca.396dcafe.svg","height":462,"width":384,"blurWidth":0,"blurHeight":0};